import HttpStrategy from './http';
export default HttpStrategy;
